import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tree_select = _resolveComponent("a-tree-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_tree_select, {
      multiple: _ctx.multiple,
      placeholder: _ctx.placeholder,
      fieldNames: { label: 'name', value: 'id' },
      "tree-data": _ctx.treeData,
      value: _ctx.value,
      "allow-clear": "",
      class: "w100",
      "show-search": "",
      "tree-node-filter-prop": "title",
      onChange: _ctx.onChange,
      onClear: _ctx.onClear,
      onSelect: _ctx.onSelect,
      disabled: _ctx.disabled,
      virtual: false
    }, null, 8, ["multiple", "placeholder", "tree-data", "value", "onChange", "onClear", "onSelect", "disabled"])
  ]))
}